enum ExportsDataTypes {
  WBS,
  PROJECT_REPORTS,
  RESOURCES_REPORT,
  PLANZONE_WBS_REPORT,
  PROJECT_TIMESHEET_REPORT,
  GANTT_REPORT,
  TASK_TIMESHEET_REPORT,
  ZONES_PROJECTS_REPORT,
  PROJECT_PORTFOLIOS_REPORT,
  RESOURCES_USAGE_REPORT,
  BUDGET_REPORT,
  RESOURCE_PROJECT_ALLOCATION_REPORT,
  OPTIMIZED_GANTT_REPORT,
  OPTIMIZED_WBS_REPORT,
  CUSTOM_CPAM_REPORT,
  RESOURCE_ALLOCATED_TIME_REPORT,
  TASK_BUDGET_REPORT,
  PROJECT_DAILY_PLANNING_REPORT,
}

export { ExportsDataTypes };
